import { get, post } from "./httpClient";

export interface ImpersonationStatus {
  is_impersonating: boolean;
  portal_admin_id: number | null;
  portal_user_id: number | null;
}

export interface StopImpersonationResponse {
  redirect: string;
}

const getStatus = (): Promise<ImpersonationStatus> => {
  return get<ImpersonationStatus>("/impersonate/status");
};

const stop = (): Promise<StopImpersonationResponse> => {
  return post<StopImpersonationResponse>("/impersonate/stop");
};

const impersonationApi = {
  getStatus,
  stop,
};

export default impersonationApi;
